import { appCtx } from '../../ApplicationContext'
import { CurrencyCode } from '../../constants'
import { JackpotsHistory } from '../../data/JsngTypes'
import { Injector } from '../../injector'
import { LobbyManager } from '../../LobbyManager'
import { createAction } from '../ReduxUtils'
import { getStore } from '../Store'

export const REQUEST_JACKPOT_HISTORY = 'REQUEST_JACKPOT_HISTORY'
export const RECEIVE_JACKPOT_HISTORY = 'RECEIVE_JACKPOT_HISTORY'
export const REQUEST_JACKPOT_ERROR = 'REQUEST_JACKPOT_ERROR'

export interface JackpotHistoryPayload {
    currencyCode: string;
    jackpotHistory: JackpotsHistory[];
}

const fetchedCurrencies = []

export const fetchJackpotPrizeHistory = () => getStore().dispatch(_fetchJackpotPrizeHistory() as any)

function _fetchJackpotPrizeHistory() {
	return dispatch => {
		const currencyCode: CurrencyCode = Injector.get(LobbyManager).getCurrencyCode()
		if (fetchedCurrencies.indexOf(currencyCode) !== -1) {
			return
		}
		dispatch(createAction(REQUEST_JACKPOT_HISTORY, {}))
		appCtx.jsngPrizeHistoryApi.fetchNewJackpotHistoryForCurrency({ currencyCode, buyIns: getBuyins(currencyCode) }, (jackpotHistory: JackpotsHistory[]) => {
			fetchedCurrencies.push(currencyCode)
			dispatch(createAction(RECEIVE_JACKPOT_HISTORY, { currencyCode, jackpotHistory }))
		}, () => {
			dispatch(createAction(REQUEST_JACKPOT_ERROR, {}))
		})
	}
}

function getBuyins(currencyCode: CurrencyCode) {
	const scBuyIns = ['0.25', '1', '5', '10']
	return currencyCode === CurrencyCode.GOLD_COINS ? ['1000', '2000', '10000', '20000'] : scBuyIns
}
